<template>
  <svg :x="x" :y="y" :width="width" :height="height" rx="4" :display="display">
    <rect
      x="0"
      y="0"
      :width="width"
      :height="height"
      rx="4"
      fill="#FFFFFF"
      stroke="#727272"
    />

    <text
      :x="width / 2"
      :y="35"
      text-anchor="middle"
      dominant-baseline="central"
      fill="#727272"
      :display="display"
      font-size="24"
    >
      {{ text }}
    </text>
    <text
      :x="width / 2"
      :y="75"
      text-anchor="middle"
      dominant-baseline="central"
      fill="#727272"
      :display="display"
      font-size="24"
      font-weight="bold"
    >
      {{ this.steps.toLocaleString() }} 歩
    </text>
  </svg>
</template>
<script>
export default {
  data: () => {
    return {
      height: 110
    }
  },
  props: {
    center: Number,
    y: String,
    display: String,
    text: String,
    steps: Number,
    unit: String
  },
  computed: {
    viewBox: function() {
      return `0 0 ${this.width} ${this.height}`
    },
    width: function() {
      return this.unit === '週' ? 320 : 260
    },
    x: function() {
      return this.center - this.width / 2
    }
  },
  methods: {}
}
</script>

<style scoped lang="scss">
svg {
  background-color: #ffffff;
}
</style>
